/*
 * jQuery viewcontroller class for loading page content with AJAX calls
 *
 * Depends on jquery history to push states, we don't handle back and 
 * forward buttons with the controller, as we don't handle url changes
 *
 * Version: 1.0
 *
 * Author: Zwaar Contrast
 *
 * Contact: postduif@zwaarcontrast.nl
 *
 * Dependencies: jQuery (1.11.x), jquery-history (https://github.com/balupton/jquery-history)
 * 
 */
(function($, window, document, undefined) {
	"use strict";

	/*
	 * 	In the constructor we wrap the element on which the plugin is called on in a jQuey object 
	 *	and expose the passed on options for usage in the init function
	 */
	var ViewController = function(elem, options) {
		this.el = elem;
		this.element = $(elem);
		this.options = options;
	};

	ViewController.prototype = {

		/*
		 *	Default values, which can be overwritten by merging with config on initialisation
		 */
		defaults:{
			titleSeparator: ' | ',
			titleSuffix : 'My Awesome Site',
			cls: 'vc-interaction',
			dataPrefix:'vc',
			responseDataID:'vc-data', //We look for this element in the responses gotten
			resizeDebounce:50,
			timelineZoom:1025,
		},

		/*
		 * Class list for our different states we use on init to determine inital state
		 */

		 classList:{
		 	'search': 'period',
		 	'home': 'home',
			 'post-type-archive-period':'timeline',
			 'post-type-archive-education': 'period',
		 	'single-period':'period',
		 	'single-window':'window',
			 'single-furtherreading':'furtherreading',
			 'single-education': 'education',
		 	'page':'page'
		 },

		/*
		 *	Initialisation funtion, read passed config and call necessary functions to launch our plugin like binding events and setting status variables
		 */
		init: function() {
			var _self = this;
			//Get the options and merge with defaults
			this.config = $.extend({}, this.defaults, this.options);

			//Status, like animating, initialised or loaded
			this.state = null;
			this.locked = false;
			this.timelineFullscreen = function(){
				if(_self.timeline){
					return !_self.timeline.isTimelineView();
				}else{
					return false;
				}
			};
			this.timelineLoaded = false;
			this.timelineNotSliding = function(){
				if(_self.timeline){
					return !_self.timeline.isCurrentlySliding();
				}else{
					return true;
				}
			};
			this.isLoading = null;
			this.isDebug = true;

			//Variables, plugin wide variables
			this.historySet = true;

			//Call functions for initialisation
			this.getElements();
			this.configureHandlers();
			this.getInitialState();
			
			this.getData();
			this.refreshInteractions();
			this.bindEvents();
			this.bindResize();

			return this;
		},
		bindEvents:function(){
			var _self = this,
			timer = false,
			doScroll=true,
			evt;

			//On state change (not our own, we prevent this) like back and forward button, reload the page
			this.window.on('statechange', function() {
				if(_self.historySet){
					window.location.reload();
				}
			});

			this.element.on( "timelineZoomToggle", function( ev, state ) {
				_self.log('Nieuwe state voor zoom van timeline gevonden...');
				_self.log(state);
				dataLayer.push({'event':'GAevent', 'eventCategory':'Timeline', 'eventAction':'Zoom', 'eventLabel':(state ? 'Zoomed in' : 'Zoomed out') });
			});

			// keyboard navigation events
			document.addEventListener( 'keydown', function( ev ) {
				var keyCode = ev.keyCode || ev.which;
				switch (keyCode) {
					//Up key
					case 38:
						if(_self.currentState == 'period'){
							ev.preventDefault();
							$('.timeline-content-switch').trigger('click');
						}
						break;
					//Down key
					case 40:
						if(_self.currentState == 'timeline'){
							ev.preventDefault();
							$('.timeline-content-switch').trigger('click');
						}
						break;
					//Enter key
					case 13:
						if(_self.currentState == 'timeline'){
							ev.preventDefault();
							$('.timeline-content-switch').trigger('click');
						}
						break;
					//Minus key
					case 189:
						if(_self.currentState == 'timeline'){
							ev.preventDefault();
							_self.element.trigger('timelineZoomOut');
						}
						break;
					//Plus key
					case 187:
						if(_self.currentState == 'timeline'){
							ev.preventDefault();
							_self.element.trigger('timelineZoomIn');
						}
						break;
				}
			});
		},
		bindResize: function(){
			//We make this construct to debounce the resize event,
			//so it doesn't call our functions a bazillion times
			var TO = false, _self = this;
			this.window.resize(function() {
				if (TO !== false){
					clearTimeout(TO);
				}
				TO = setTimeout(function(){
					//Do stuff here
					if(_self.timeline && !_self.timeline.isFullscreen){
						//Check width to zoom out the timeline if necessary
						if(_self.window.width()<_self.config.timelineZoom){
							$('.timeline-zoom-switch').trigger('click');
						}
					}

				}, _self.config.resizeDebounce);
			});

		},
		getElements:function(){
			this.window = $(window);
			this.docElem = window.document.documentElement;
		},
		getData: function(){
			//Get the site title, exposed by wordpress
			this.url = ajaxurl;
		},
		refreshInteractions:function(){
			var _self = this;
			
			//Find all elements on the page which have our class
			this.interactives = this.element.find('.'+this.config.cls);
			_self.log('refresh interecation');
			//Loop through interactive elements and bind our handleInteraction function
			for (var i = 0; i < this.interactives.length; i++) {
				$(this.interactives[i]).off('click').on( 'click', null,{_self:_self}, _self.handleInteraction )
			}
		},
		handleInteraction:function(event){
			//Get context to access other shizzle in this plugin
			var _self = event.data['_self'];
			var el = $(this);

			//Prevent hash in href being added to url
			event.preventDefault();

			//Get the id
			var id = el.attr('data-'+_self.config.dataPrefix+'-id');
			_self.log('id found: '+id);

			//Get the types
			var types = el.attr('data-'+_self.config.dataPrefix+'-type').split(',');
			//Check amount of types (can be multiple in case of toggling button, so we determine which one we are)
			if(types.length>1){
				_self.log('types found: '+types);

				//Determine type from the array gotten from data attribute based on the current state (we presume that we can't click on a toggling button if our current state isn't one of the found states)
				var index = types.indexOf(_self.currentState);
				if(index!==-1){
					var type = index==0 ? types[1] : types[0];
					_self.log('type found: '+type);
				}else{
					_self.log('Current state is not one of the toggle-able states, wtf dude');
				}
			}else{
				_self.log('type found: '+types);
				var type = types;
			}

			//Get the url
			var url = el.attr('data-'+_self.config.dataPrefix+'-url');
			_self.log('url found: '+url);

			//Get the current interaction data
			_self.interaction = _self.handlers[_self.currentState+'-to-'+type];

			if(_self.interaction){
				_self.log('Interaction found for: '+ _self.currentState+'-to-'+type);
				_self.loadPage(id,_self.interaction,url,el);
				dataLayer.push({'event':'GAevent', 'eventCategory':'Interaction', 'eventAction':_self.currentState+'-to-'+type, 'eventLabel':url });
			}else{
				_self.log('No interaction found for: '+ _self.currentState+'-to-'+type);
			}
		},
		getInitialState:function(){
			//On init we need to get the current state from the body class
			var classList = this.el.classList, _self = this;

			//Grep on classlist to match on our classlist
			var state = jQuery.grep(classList, function(cls,i){
  				return (_self.classList[cls]!==undefined)? true : false
			});

			//Check for state
			if(state.length==1){
				this.currentState = _self.classList[state[0]];

				//Check initializer for the found current state and call
				if(this.initializers[this.currentState]){
					//Check defaults ready
					if(this.initializers['default'].ready){
						this.initializers['default'].ready.call(_self)
					}
					//Check defaults load
					if(this.initializers['default'].load){
						$(window).load(this.initializers['default'].load);
					}
					//Check ready
					if(this.initializers[this.currentState].ready){
						this.initializers[this.currentState].ready.call(_self)
					}
					//Check load
					if(this.initializers[this.currentState].load){
						$(window).load(this.initializers[this.currentState].load);
					}
				}
			}else{
				this.currentState = "unknown";
			}

			this.log('Initial state determined: ' +this.currentState);
		},
		configureHandlers:function(){
			//Functions to call when an initial state is determined or the dom has changed
			this.initializers = {
				'timeline':{
					'ready':this.timelineInitialise,
				},
				'period':{
					'ready':this.periodInitialise,
				},
				'window':{
					'load':this.windowInitialise,
				},
				'furtherreading':{
					'ready':this.pageInitialise,
				},
				'education': {
					'ready': this.pageInitialise,
				},
				'page':{
					'ready':this.pageInitialise
				},
				'default':{
					'ready':this.defaultInitialise,
				},
				'home':{
					'ready':this.timelineInitialise,
				}
			}
			//Our mo-fo handler construction
			this.handlers = {
				'timeline-to-period':{
					'state':'period',
					'pageLoad':true,
					'exclude':'header,topnav,footer,timeline,page-content',
					'beforeSend':this.beforePeriodLoad,
					'complete':this.afterPeriodLoad,
					'error':this.onPeriodLoadError,
					'success':this.onPeriodLoadSuccess,
					'onReady':this.initializers['period'].ready,
					'condition':['timelineFullscreen','timelineNotSliding'],
					'lock':'timelineToggleComplete',
					'modernizrClasses':['csstransforms','csstransforms3d', 'csstransitions']
				},
				'period-to-timeline':{
					'state':'timeline',
					'url':'/tijdlijn/',
					'title':'Tijdlijn',
					'pageLoad':false,
					'action':this.toggleTimeline,
					'lock':'timelineToggleComplete',
					'modernizrClasses':['csstransforms','csstransitions']
				},
				'period-to-window':{
					'state':'window',
					'pageLoad':true,
					'exclude':'header,topnav,header-image',
					'beforeSend':this.beforeWindowLoad,
					'complete':this.afterWindowLoad,
					'error':this.onWindowLoadError,
					'success':this.onWindowLoadSuccess,
					'onReady':this.initializers['window'].ready,
					'onDomLoad':this.initializers['window'].load,
					'minWidth':768,
					'modernizrClasses':['csstransforms','csstransforms3d', 'csstransitions']
				},
				'window-to-period':{
					'state':'period',
					'pageLoad':true,
					'exclude':'header,footer,page-content',
					'split':true,
					'beforeSend':this.beforePeriodLoadFromWindow,
					'complete':this.afterPeriodLoadFromWindow,
					'error':this.onPeriodLoadErrorFromWindow,
					'success':this.onPeriodLoadSuccessFromWindow,
					'onReady':this.initializers['period'].ready,
					'minWidth':768,
					'modernizrClasses':['csstransforms','csstransforms3d', 'csstransitions']
				},
				'window-to-window':{
					'state':'window',
					'pageLoad':true,
					'exclude':'header,topnav,header-image,footer',
					'beforeSend':this.beforeWindowLoadFromWindow,
					'complete':this.afterWindowLoadFromWindow,
					'error':this.onWindowLoadErrorFromWindow,
					'success':this.onWindowLoadSuccessFromWindow,
					'onReady':this.initializers['window'].load,
					'modernizrClasses':['csstransforms','csstransforms3d', 'csstransitions']
				},
			}

		},
		setState:function(title,url,id){
			//Check url for leading slash
			if(url.indexOf('/')!==1){
				url = '/'+url;
			}

			//Construction used for disabling reloads when pushing our state but enabling on window.stateChange
			this.historySet = false;
			History.pushState({},title,url);
			this.historySet = true;

			console.log(title);
			dataLayer.push({
				'event':'VirtualPageview',
				'virtualPageURL':url,
				'virtualPageTitle' : title
			});

			this.element.attr('data-'+this.config.dataPrefix+'-page-id',id);

		},
		getPageTitle:function(title){
			return title + this.config.titleSeparator + this.config.titleSuffix;
		},
		getPageTitleFromDataElement:function(){
			var title = $("#"+this.config.responseDataID).attr('data-'+this.config.dataPrefix+'-title');
			if(title){
				return this.getPageTitle(title);
			}
		},
		loadPage:function(id,interaction,url,el){
			var _self = this;
			//Check for id and excludes
			if(!id||!interaction){this.log('Invalid parameters for loadPage'); return false;}
			
			//Check for a minimum width condition
			if(interaction['minWidth'] && this.window.width() <= interaction['minWidth']){
				window.location.href = '/'+url;
				return false;
			}
			//Check for Modernizr classes conditions
			if(interaction['modernizrClasses']){
				//Get body classes
				var htmlClasses = document.documentElement.classList;
				//Loop through all Modernizr classes
				for (var i = interaction['modernizrClasses'].length - 1; i >= 0; i--) {
					if(!htmlClasses.contains(interaction['modernizrClasses'][i])){
						if(interaction.url){
							window.location.href = interaction.url;
						}else{
							window.location.href = '/'+url;
						}
						return false;
					}
				};
			}
			//Check if application is locked
			if(this.locked){
				this.log('Application locked. Aborting.');
				return false;
			}

			//Check if this interaction has a condition that is not met
			if(interaction['condition']){
				for (var i = interaction['condition'].length - 1; i >= 0; i--) {
					if (typeof(this[interaction['condition'][i]]) == 'function') {
						if(this[interaction['condition'][i]].call() === false){
							_self.log('Condition method not met. Abort.');
							return false;
						};
					}else{
						if(this[interaction['condition'][i]] === false){
							_self.log('Condition not met. Abort.');
							return false;
						}
					}
				};
			}

			if(interaction['lock']){
				this.log('Adding lock: "'+interaction['lock']+'"');
				this.locked = true;
				this.element.one(interaction['lock'],function(){
					_self.locked = false;
					_self.log('Application lock "'+interaction['lock']+'" removed.');
				})
			}

			//Construct the data object
			var data_object = {};
			data_object.action = 'get_post';
			data_object.exclude = interaction['exclude'];
			data_object.postid = id;

			//Check if we need to split on an id (currently)
			if(interaction.split){
				data_object.split = this.getCurrentPageID();
			}

			//Check if the current interaction needs loading of content via AJAX
			if(interaction.pageLoad){
				//Check if we are doing the same request as the one before
				if(JSON.stringify(data_object) === JSON.stringify(this.lastRequestData)){
					_self.log('Same request as the previous')
					if(interaction['complete']){
						interaction['complete'].call(_self);
					}else{
						_self.log('Interaction not found for complete')
					}
					_self.currentState = interaction['state'];
					_self.setState(_self.getPageTitleFromDataElement(),url,id);
				}else{
					//Perform AJAX
					$.ajax({
						type:"POST",
						url: this.url,
						data: data_object,
						beforeSend:function(jqXHR, settings ){
							_self.log('beforeSend');

							//Save data_object for comparison in future requests
							_self.lastRequestData = data_object;

							//Delete the dataElement if found
							$("#"+_self.config.responseDataID).remove();

							if(interaction['beforeSend']){
								interaction['beforeSend'].call(_self,el);
							}else{
								_self.log('Interaction not found for beforeSend')
							}

							//Trigger loading state
							_self.element.trigger('setLoadingState');
						},
						complete:function(jqXHR,status){
							_self.log('complete');

							if(interaction['complete']){
								interaction['complete'].call(_self);
							}else{
								_self.log('Interaction not found for complete')
							}
							_self.currentState = interaction['state'];
							
							_self.setState(_self.getPageTitleFromDataElement(),url,id);

							_self.refreshInteractions();

							$('.do-container-sized:not(.is-container-sized)').FullSize({});
						},
						error:function(jqXHR, textStatus, errorThrown ){
							_self.log('error');
							//Disable loading state
							$('body').trigger('disableLoadingState');

							if(interaction['error']){
								interaction['error'].call();
							}else{
								_self.log('Interaction not found for error');
							}
						},
						success:function(data,status,jqXHR){
							_self.log('succes');
							
							//Disable loading state
							$('body').trigger('disableLoadingState');

							if(interaction['success']){
								interaction['success'].call(_self,data);
								if(interaction['onReady']){
									interaction['onReady'].call(_self);
								}
							}else{
								_self.log('Interaction not found for success')
							}
						}
					});
				}
			}else{
				if(interaction.action){
					interaction.action.call(_self);
				}
				_self.currentState = interaction['state'];
				_self.setState(_self.getPageTitle(interaction['title']),interaction['url'],id);
				_self.refreshInteractions();
			}
		},
		defaultInitialise:function(){
			var _self = this;
			this.initialiseMenu();
			this.element.off('timelineSlided').on('timelineSlided',function(ev,slide){
				if(slide == 0){
					if(_self.currentState != 'home'){
						_self.currentState = 'home';
						_self.setState(_self.config.titleSuffix,'/','');
						_self.refreshInteractions();
					}
					if(_self.timeline && _self.timeline.isFullscreen)
						$('.top-menu-home-link,.timeline-navigation').stop().fadeOut('fast');
				}else{
					if(_self.currentState == 'home'){
						_self.currentState = 'timeline';
						_self.setState(_self.getPageTitle('Tijdlijn'),'/tijdlijn/','');
						_self.refreshInteractions();
					}
					$('.top-menu-home-link,.timeline-navigation').stop().fadeIn('fast');
				}
			});
		},
		pageInitialise:function(){
			$('.to-top').ToTop();
			this.setPreviousLink('furtherreading-back-to-window','window',document.referrer);
			$('.window-content').LinkPositioner({
				linkIdentifier:'link-id',
				sidebarLinkClass:'window-content-links-item',
				contentLinkClass:'window-content-links-body-link',
				resizeDebounce:50,
				horizontalThreshold:1240,
				debug:false
			});
		},
		timelineInitialise:function(){
			this.initialiseTimeline();
		},
		periodInitialise:function(){
			this.initialiseTimeline();

			//Bind to top link
			$('.to-top').ToTop();
			
			this.onPeriodReady();
			this.window.trigger('resize');
		},
		windowInitialise:function(_self){
			$('.page-content').children().unwrap();
			$('.window-content').LinkPositioner({
				linkIdentifier:'link-id',
				sidebarLinkClass:'window-content-links-item',
				contentLinkClass:'window-content-links-body-link',
				resizeDebounce:50,
				horizontalThreshold:1240,
				debug:false
			});
			// $('.window-readmore-list').ReadMoreList({
			// 	resizeDebounce: 50,
			// 	linksVisible: 3,
			// 	toggleAble: false,
			// 	toggle:$('.window-readmore-loadmore-link'),
			// 	toggleHiddenClass:'is-window-readmore-loadmore-link-invisible'
			// },{
			// 	readMore: 'laad meer',
			// 	readLess: 'laad minder'
			// });

			//Bind to top link
			$('.to-top').ToTop();

		},
		beforePeriodLoad:function(){
			$('.page-content').html('');
		},
		afterPeriodLoad:function(data){
			this.toggleTimeline();
		},
		onPeriodLoadSuccess:function(data){
			var _self = this;
			$('.page-content').html(data);
		},
		onPeriodReady:function(){
			//Nothing yet
		},
		beforeWindowLoad:function(el){
			//Variables
			this.windowX = this.getViewport('x');
			this.windowY = this.getViewport('y');

			//Get elements to prepare for transition

			//Get the item clicked on in which we find our elements and add class to recognize later
			this.item = el.parents('.period-window, .window-header');
			this.wrapper = this.item.find('.wrapper');
			this.image = this.item.find('.period-window-image, .window-header-image');
			this.button = this.item.find('.period-window-content-period-read,.window-header-content-period-read');

			this.button.fadeOut();
			$('.period-window').removeClass('period-window-last')
			this.item.addClass('period-window-last');
		},
		afterWindowLoad:function(){
			var _self = this;
			//Perform animations
			TweenLite.to(this.wrapper, 0.4, {'max-width':this.windowX+'px',ease: Power1.easeInOut,delay:0});
			TweenLite.to(this.image, 0.4, {'margin':"0",ease: Power1.easeInOut,delay:0});
			TweenLite.to(this.image, 0.4, {'width':"100%",ease: Power1.easeInOut,delay:0});
			TweenLite.to(this.item, 0.4, {'height':this.windowY*0.75+'px',delay:0.4,ease:Power1.easeInOut,onComplete:function(){_self.afterTransitionToWindow(_self);}});
		
			//Perform scroll
			TweenLite.to(window, 0.4, {scrollTo:{y:this.item.offset().top},delay:0.4,ease:Power1.easeInOut});
		},
		afterTransitionToWindow:function(_self){
			$("#timeline-arrow-navigation, #timeline, #vc-data,footer, .period-lead,section").not(this.item).fadeOut().remove();
			$('.page-content').css({'top':0});
			this.timelineLoaded = false;

			this.item.find('.period-window-content-window, .window-header-content-window').addClass('is-visible');
			this.item.find('.period-window-content-period,.window-header-content-period').removeClass('is-visible');

			
			this.element.removeClass('after-transition-period');
			this.element.addClass('after-transition-window');

			this.wrapper.removeAttr( 'style' );
			this.image.removeAttr( 'style' );
			this.item.removeAttr( 'style' );

		},
		onWindowLoadError:function(){

		},
		onWindowLoadSuccess:function(data){
			//$('.page-content').append(data);
			var _self = this;
			window.setTimeout(function(){
				$('.page-content').append(data).imagesLoaded().then(function(){
	            	$(window).trigger('repositionLinks');
				});
				document.title = _self.getPageTitleFromDataElement();
				_self.initializers['window'].load.call();
				_self.refreshInteractions();
				TweenLite.from(('.wrapper-window-content'), 1, {'opacity':'0',delay:0,ease:Power1.easeInOut});
			}
			,900)
		},
		initialiseMenu:function(){
			var _self =this;
			//Handling for the ever present menu
			var menuEvent = 'disableInteractions';
			$('.top-menu-open-link, .home-cta-link-about').off('click').on('click',function(ev){
				ev.preventDefault();
				if($('body').hasClass('is-top-menu-open')){
					//Menu is closing, unlock the application
					menuEvent = 'enableInteractions';
					_self.locked = false;
					_self.element.removeClass('is-top-menu-open');
					_self.element.removeClass('stop-scrolling');
					_self.element.trigger(menuEvent);

					if(_self.currentState == 'home'){
						$('.top-menu-home-link').stop().fadeOut('fast');
					}

					//Push GA event
					dataLayer.push({'event':'GAevent', 'eventCategory':'Top Menu', 'eventAction':'Toggle Menu', 'eventLabel':'Menu closed' });
				}else{
					menuEvent = 'disableInteractions';
					//Check if application is locked. If so, we can't open the menu.
					if(!_self.locked){
						//Menu is opening, lock the application
						_self.locked = true;
						_self.element.addClass('is-top-menu-open');
						_self.element.addClass('stop-scrolling');
						_self.element.trigger(menuEvent);
						dataLayer.push({'event':'GAevent', 'eventCategory':'Top Menu', 'eventAction':'Toggle Menu', 'eventLabel':'Menu opened' });
					}

					if(_self.currentState == 'home'){
						$('.top-menu-home-link').stop().fadeIn('fast');
					}
				}
				return false;
			});

			$('.top-menu-search-link').off('click').on('click',function(ev){
				ev.preventDefault();
				if($('body').hasClass('is-search-menu-visible')){
					//Menu is closing, unlock the application
					_self.locked = false;
					_self.element.removeClass('is-search-menu-visible');
					_self.element.removeClass('stop-scrolling');

					if(_self.currentState == 'home'){
						$('.top-menu-home-link').stop().fadeOut('fast');
					}

				}else{
					// menuEvent = 'disableInteractions';
					//Check if application is locked. If so, we can't open the menu.
					if(!_self.locked){
						//Menu is opening, lock the application
						_self.locked = true;
						_self.element.addClass('is-search-menu-visible');
						_self.element.addClass('stop-scrolling');
						$('.search-field').focus();
					}

					if(_self.currentState == 'home'){
						$('.top-menu-home-link').stop().fadeIn('fast');
					}
				}
				return false;
			});

			$('.top-menu-home-link').off('click').on('click',function(e){
				//If on home timeline fully visible and top menu not open
				if(_self.timelineFullscreen.call() && !$('body').hasClass('is-top-menu-open') && _self.currentState != 'home'){
					e.preventDefault();
					dataLayer.push({'event':'GAevent', 'eventCategory':'Top Menu', 'eventAction':'Homebutton', 'eventLabel':'Slide to home' });
					_self.element.trigger('moveToSlideWithIndex',1);
					return false;
				}

				//If on home, timeline zoomed in and top menu open, close topmenu
				if(_self.timeline && _self.currentState == 'home' && $('body').hasClass('is-top-menu-open') && _self.timeline.isFullscreen){
					e.preventDefault();
					$('.top-menu-open-link').trigger('click');
					return false;
				}

				//If on home, timeline zoomed out without topmenu open, zoom in timeline
				if(_self.timeline && _self.currentState == 'home' && !$('body').hasClass('is-top-menu-open') && !_self.timeline.isFullscreen){
					e.preventDefault();
					$('.timeline-zoom-switch').trigger('click');
					return false;
				}
			});
		},
		initialiseTimeline:function(){
			var _self = this;
			if(!this.timelineLoaded){
				this.timelineLoaded = true
			
				var timeline_nav = document.getElementById( 'timeline-navigation' ),
					timeline_arrow_nav = document.getElementById( 'timeline-arrow-navigation' ),
					timeline = document.getElementById( 'timeline' ),
					switchBtnn = timeline_nav.querySelector( '.timeline-zoom-switch' ),
					nextBtn = timeline_arrow_nav.querySelector( '.timeline-arrow-navigation-arrow-next' ),
					prevBtn = timeline_arrow_nav.querySelector( '.timeline-arrow-navigation-arrow-previous' ),
					toggleBtnn = function() {
						if( slideshow.isFullscreen ) {
							classie.add( switchBtnn, 'view-maxi' );
							classie.add( timeline_arrow_nav, 'view-maxi');
							classie.add( timeline_nav, 'view-maxi');
							if(_self.currentState == 'home')
								$('.top-menu-home-link,.timeline-navigation').stop().fadeIn('fast');
						}
						else {
							classie.remove( switchBtnn, 'view-maxi' );
							classie.remove( timeline_arrow_nav, 'view-maxi');
							classie.remove( timeline_nav, 'view-maxi');
							if(_self.currentState == 'home')
								$('.top-menu-home-link,.timeline-navigation').stop().fadeOut('fast');
						}
					},
					toggleCtrls = function() {
						if( !slideshow.isContent ) {
							classie.add( timeline_arrow_nav, 'hide' );
							classie.add( timeline, 'is-content-open' );
							classie.add( timeline_nav, 'is-content-open' );
						}
					},
					toggleCompleteCtrls = function() {
						if( !slideshow.isContent ) {
							classie.remove( timeline_arrow_nav, 'hide' );
							classie.remove( timeline, 'is-content-open' );
							classie.remove( timeline_nav, 'is-content-open' );
						}
					},
					slideshow = new DragSlideshow( timeline, { 
						// toggle between fullscreen and minimized slideshow
						onToggle : toggleBtnn,
						// toggle the main image and the content view
						onToggleContent : toggleCtrls,
						// toggle the main image and the content view (triggered after the animation ends)
						onToggleContentComplete : toggleCompleteCtrls,
						no3dtransforms: $('html').hasClass('no-csstransforms3d')
					}),
					toggleSlideshow = function() {
						slideshow.toggle();
						toggleBtnn();
					},
					nextSlideshow = function(e){
						e.preventDefault();
						slideshow.next();
						return false;
					},
					prevSlideshow = function(e){
						e.preventDefault();
						slideshow.previous();
						return false;
					};

					_self.timeline = slideshow;

				// toggle between fullscreen and small slideshow
				switchBtnn.addEventListener( 'click', toggleSlideshow );
				nextBtn.addEventListener( 'click', nextSlideshow );
				prevBtn.addEventListener( 'click', prevSlideshow );

				$('.home-windows-link').off('click').on('click',function(ev){
					ev.preventDefault();
					var slideIndex = $(this).data('slideindex');
					if(slideIndex){
						_self.element.trigger('moveToSlideWithIndex',slideIndex);
						dataLayer.push({'event':'GAevent', 'eventCategory':'Homepage', 'eventAction':'Slide', 'eventLabel':'Button: '+$(this).text() });
					}
					return false;
				});

				$('.home-cta-link:not(.home-cta-link-about)').off('click').on('click',function(ev){
					ev.preventDefault();
					_self.element.trigger('moveToSlideWithIndex',2);
					dataLayer.push({'event':'GAevent', 'eventCategory':'Homepage', 'eventAction':'Slide', 'eventLabel':'Button: Go back in time' });
					return false;
				});
			}
		},
		beforePeriodLoadFromWindow:function(){
			$("#top-menu").fadeOut(300, function() { $(this).remove(); });
			$('.window-content,.window-readmore,.window-header-next,.footer-single-window').remove();
			
		},
		afterPeriodLoadFromWindow:function(){
			this.initialiseTimeline();
			this.initialiseMenu();
		},
		onPeriodLoadErrorFromWindow:function(){

		},
		onPeriodLoadSuccessFromWindow:function(data){
			var _self = this;
			var parts = data.split('<!--PAGESPLIT-->');

			this.element.prepend(parts[0])
			$('.period-lead').nextAll().andSelf().wrapAll('<div class="page-content"></div>');
			
			$('.page-content').append(parts[1]);

			var item = $('.window-header:not(.window-header-next), .period-window-last');

			TweenLite.to(window, 0, {scrollTo:{y: item.offset().top},delay:0,ease:Power1.easeInOut});
			TweenLite.to(window, 0.2, {scrollTo:{y: item.offset().top-40},delay:0,ease:Power1.easeInOut});

			item.find('.window-header-content-window,.period-window-content-window').removeClass('is-visible');

			item.find('.window-header-content-period,.period-window-content-period').addClass('is-visible');

			var imageWidth = (_self.getViewport('x')<1240 ? 45 : 40);
			imageWidth = (_self.getViewport('x')<768 ? 100 : imageWidth);

			TweenLite.to(item.find('.wrapper'), 0.4, {'max-width':'1240px',ease: Power1.easeInOut,delay:0.4});
			TweenLite.to(item.find('.window-header-image, .period-window-image'), 0.4, {'width':imageWidth+"%",ease: Power1.easeInOut,delay:0.4,onComplete:function(){afterTransitionToPeriod(_self);}});

			if(imageWidth==45){
				if(item.is('.period-window-odd, .window-header-odd')){
					TweenLite.to(item.find('.window-header-image, .period-window-image'), 0.4, {"margin-right":"5%",ease: Power1.easeInOut,delay:0.4});
				}else{	
					TweenLite.to(item.find('.window-header-image, .period-window-image'), 0.4, {"margin-left":"5%",ease: Power1.easeInOut,delay:0.4});
				}
			}
			TweenLite.to(item, 0.4, {'height':'350px',delay:0,ease:Power1.easeInOut,onStart:beforeTransitionToPeriod});

			function afterTransitionToPeriod(_self){
				var item = $('.window-header:not(.window-header-next), .period-window-last');
				item.find('.period-window-content-period-read,.window-header-content-period-read').fadeIn();
				
				var wrapper = item.find('.wrapper')
				var image = item.find('.window-header-image, .period-window-image');


				item.removeAttr('style');
				wrapper.removeAttr('style');

				//Give the image a little more time to make sure the margin transition is done yet.
				setTimeout(function(){
					image.removeAttr('style');
				}, 50);

				_self.element.removeClass("after-transition-window");
				_self.element.addClass("after-transition-period");
			}
			function beforeTransitionToPeriod(){
				$('.window-header .wrapper, .period-window-last .wrapper').css({'max-width': _self.getViewport('x')});
				$('.page-content').css({'top':'35%'});	
			}
		},
		beforeWindowLoadFromWindow:function(){
			this.log('beforeWindowLoadFromWindow fired');
		},
		afterWindowLoadFromWindow:function(){
			this.log('afterWindowLoadFromWindow fired');
		},
		onWindowLoadErrorFromWindow:function(){
			this.log('onWindowLoadErrorFromWindow fired');
		},
		onWindowLoadSuccessFromWindow:function(data){
			var _self = this;
			var windowHeader = this.element.find('.window-header-next');
			var windowHeaderImage =windowHeader.find('.window-header-image');
			var translationValue  = windowHeader.get(0).getBoundingClientRect().top;
			
			var prevWindow = this.element.find('.period-window,.window-header:not(.window-header-next)').first();
			var prevWindowContent = prevWindow.nextAll('.window-content:first');
			var prevWindowReadMore = prevWindowContent.nextAll('.window-readmore:first');
			var prevWindowToTop = prevWindow.nextAll('.footer-single-window');

			var imageTranslation = (($(window).height()*.75)-360)/2;

			$('.top-menu').hide();

			windowHeader.addClass('window-header-next-transitioning');
			windowHeaderImage.css('transform','translate3d(0,-'+imageTranslation+'px,0)');
			this.element.append(data).addClass('has-window-to-window-transition').css({ "transform": "translate3d(0, -"+ translationValue +"px, 0)" }).imagesLoaded().then(function(){
            	$(window).trigger('repositionLinks');
        	});

			TweenLite.to(windowHeaderImage.get(0), .450, {y: 0, z: 0.01});

			setTimeout(function(){
				_self.element.removeClass('has-window-to-window-transition');
				prevWindow.remove();
				prevWindowContent.remove();
				prevWindowReadMore.remove();
				prevWindowToTop.remove();

				TweenLite.to(window, 0, {scrollTo:{y:0},delay:0});
				_self.element.css({ "transform": "" });
				windowHeader.removeClass('window-header-next');
				$('.top-menu').fadeIn('fast');
			}, 550);
		},
		toggleTimeline:function(){
			this.element.trigger('toggleContent');
		},
		getCurrentPageID:function(){
			return this.element.attr('data-'+this.config.dataPrefix+'-page-id');
		},
		setPreviousLink:function(classname,posttype,prevurl){
			var data_object = {};
			data_object.action = 'getpreviouslink',
			data_object.posttype = posttype;
			data_object.url = prevurl;

			$.ajax({
				type:"POST",
				url: ajaxurl,
				data: data_object,
				beforeSend:function(jqXHR, settings ){
				},
				complete:function(jqXHR,status){
				},
				error:function(jqXHR, textStatus, errorThrown ){
				},
				success:function(data,status,jqXHR){
					if(data !== '0')
						$('.'+classname).attr('href',data);
				}
			});
		},
		getViewport: function(axis){
			var client, inner;
			//Check x or y axis
			if( axis === 'x' ) {
				client = this.docElem['clientWidth'];
				inner = window['innerWidth'];
			}else if( axis === 'y' ) {
				client = this.docElem['clientHeight'];
				inner = window['innerHeight'];
			}
			return client < inner ? inner : client;
		},
		log:function(msg1,msg2,msg3,msg4,msg5){
			if(this.isDebug && window.console){
				console.log(msg1,msg2?msg2:"",msg3?msg3:"",msg4?msg4:"",msg5?msg5:"");
			}
		}		
	};

	//Extend Jquery with the ViewController function/object
	$.fn.ViewController = function(options) {
		//Do for each of the passed elements
		return this.each(function() {
			//Construct new ViewController object and call initialisation function
			new ViewController(this, options).init();
		});
	};

	// Fn to allow an event to fire after all images are loaded
	$.fn.imagesLoaded = function () {

	    var imgs = this.find('img[src!=""]');
	    // if there's no images, just return an already resolved promise
	    if (!imgs.length) {return $.Deferred().resolve().promise();}

	    // for each image, add a deferred object to the array which resolves when the image is loaded
	    var dfds = [];  
	    imgs.each(function(){
	        var dfd = $.Deferred();
	        dfds.push(dfd);
	        var img = new Image();
	        img.onload = function(){dfd.resolve();};

	        //On error, complete anyway...
	        img.onerror = function(){dfd.resolve();};
	        img.src = this.src;
	        if($(img).complete) $(img).trigger('load');

	    });

	    // return a master promise object which will resolve when all the deferred objects have resolved
	    // IE - when all the images are loaded
	    return $.when.apply($,dfds);

	}
})(jQuery, window, document);
